import Et from './EvaluationTile'
import El from './EvaluationList'
import EvaluationContainer from './EvaluationContainer'

const EvaluationTile = EvaluationContainer(Et)
const EvaluationList = EvaluationContainer(El)

export { EvaluationTile, EvaluationList }
